import Icon from '../../assets/service-status_dark.svg?react';
import ServiceStatusWrapper from '../../components/servicestatus/ServiceStatusWrapper';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

export default {
	relativePath: 'service-status',
	label: {
		id: 'route.label.servicestatus.name',
		defaultValue: 'Service Status'
	},
	iconSvg: Icon,
	component: ServiceStatusWrapper,
	requiredAuthorities: ['READ_SERVICE_STATUS']
} satisfies RouteConfig;
